import MissingItemInfo from './MissingItemInfo';

const ProductMissingItemInfo = () => <MissingItemInfo text="Varan saknas i sortimentet." />;

export default ProductMissingItemInfo;
